package diana.soleil.design.iraniancanadienbazzar.feature.addbusiness

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.KeyboardType
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppTextField
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme

/** White surface card used to group a step's fields (matches the Stitch wizard cards). */
@Composable
internal fun WizardCard(content: @Composable ColumnScope.() -> Unit) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .background(AppTheme.colors.surface, AppTheme.shapes.card)
            .padding(AppTheme.spacing.lg),
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
        content = content,
    )
}

/** A plain labelled single-line input (non-localized fields: address, city, postal code, …). */
@Composable
internal fun LabeledField(
    label: String,
    value: String,
    onValueChange: (String) -> Unit,
    placeholder: String,
    keyboardType: KeyboardType = KeyboardType.Text,
    isError: Boolean = false,
    errorText: String? = null,
) {
    Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
        Text(text = label, style = AppTheme.typography.labelMd, color = AppTheme.colors.onSurfaceVariant)
        AppTextField(
            value = value,
            onValueChange = onValueChange,
            placeholder = placeholder,
            keyboardType = keyboardType,
            isError = isError,
            supportingText = errorText?.takeIf { isError },
        )
    }
}

/** A muted informational note with a leading icon (address help, verification-only notes, …). */
@Composable
internal fun InfoNote(text: String, icon: String = "info") {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .background(AppTheme.colors.surfaceContainer, AppTheme.shapes.card)
            .padding(AppTheme.spacing.lg),
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
    ) {
        AppIcon(name = icon, size = AppTheme.sizes.iconSm, tint = AppTheme.colors.onSurfaceVariant)
        Text(text = text, style = AppTheme.typography.bodySm, color = AppTheme.colors.onSurfaceVariant)
    }
}

/** Small section label above a group (e.g. "Brand Assets", "Proof of Business"). */
@Composable
internal fun SectionHeading(text: String) {
    Text(text = text, style = AppTheme.typography.labelMd, color = AppTheme.colors.onSurfaceVariant)
}
